/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-builder/index.ts to modify the generation of this file.


import { ComponentBuilder } from '@sitecore-jss/sitecore-jss-nextjs';

import { SeoFooterLinkList, SeoFooter, IconLinkList, SiteFooter, Header, PageStructure, NavMenu, AlertBanner, RichText, IntroductionCta } from '@greystar/ui';
import { BYOCWrapper, FEaaSWrapper } from '@sitecore-jss/sitecore-jss-nextjs';

import * as CdpPageView from 'src/components/CdpPageView';
import * as ColumnSplitter from 'src/components/ColumnSplitter';
import * as Container from 'src/components/Container';
import * as ContentBlock from 'src/components/ContentBlock';
import * as FEAASScripts from 'src/components/FEAASScripts';
import * as Image from 'src/components/Image';
import * as LinkList from 'src/components/LinkList';
import * as Navigation from 'src/components/Navigation';
import * as PageContent from 'src/components/PageContent';
import * as PartialDesignDynamicPlaceholder from 'src/components/PartialDesignDynamicPlaceholder';
import * as Promo from 'src/components/Promo';
import * as RowSplitter from 'src/components/RowSplitter';
import * as Title from 'src/components/Title';
import * as DataDogInit from 'src/components/DataDog/DataDogInit';
import * as articlepagestructure from 'src/components/Editorial/article-page-structure';
import * as contactpagestructure from 'src/components/Editorial/contact-page-structure';
import * as editorialbreadcrumb from 'src/components/Editorial/editorial-breadcrumb';
import * as homepagestructure from 'src/components/Editorial/home-page-structure';
import * as FlexibleHero from 'src/components/content/FlexibleHero';
import * as cardlist from 'src/components/content/card-list';
import * as card from 'src/components/content/card';
import * as faqs from 'src/components/content/faqs';
import * as heroheader from 'src/components/content/hero-header';
import * as icontextcardblock from 'src/components/content/icon-text-card-block';
import * as icontextcarditem from 'src/components/content/icon-text-card-item';
import * as imageandtextblock from 'src/components/content/image-and-text-block';
import * as imagewithcontentblocks from 'src/components/content/image-with-content-blocks';
import * as introduction from 'src/components/content/introduction';
import * as textcardblock from 'src/components/content/text-card-block';
import * as textcarditem from 'src/components/content/text-card-item';
import * as CommunityCardRowprops from 'src/components/content/CommunityCardRow/CommunityCardRow.props';
import * as CommunityCardRow from 'src/components/content/CommunityCardRow/CommunityCardRow';
import * as GuideOverview from 'src/components/location-guides/GuideOverview';
import * as childguides from 'src/components/location-guides/child-guides';
import * as guidefaqs from 'src/components/location-guides/guide-faqs';
import * as guideheader from 'src/components/location-guides/guide-header';
import * as guidenavigationheader from 'src/components/location-guides/guide-navigation-header';
import * as guidenavigationstructure from 'src/components/location-guides/guide-navigation-structure';
import * as guidestructure from 'src/components/location-guides/guide-structure';

export const components = new Map();
components.set('SeoFooterLinkList', SeoFooterLinkList);
components.set('SeoFooter', SeoFooter);
components.set('IconLinkList', IconLinkList);
components.set('SiteFooter', SiteFooter);
components.set('Header', Header);
components.set('page-structure', PageStructure);
components.set('nav-menu', NavMenu);
components.set('alert-banner', AlertBanner);
components.set('RichText', RichText);
components.set('introduction-cta', IntroductionCta);
components.set('BYOCWrapper', BYOCWrapper);
components.set('FEaaSWrapper', FEaaSWrapper);

components.set('CdpPageView', CdpPageView);
components.set('ColumnSplitter', ColumnSplitter);
components.set('Container', Container);
components.set('ContentBlock', ContentBlock);
components.set('FEAASScripts', FEAASScripts);
components.set('Image', Image);
components.set('LinkList', LinkList);
components.set('Navigation', Navigation);
components.set('PageContent', PageContent);
components.set('PartialDesignDynamicPlaceholder', PartialDesignDynamicPlaceholder);
components.set('Promo', Promo);
components.set('RowSplitter', RowSplitter);
components.set('Title', Title);
components.set('DataDogInit', DataDogInit);
components.set('article-page-structure', articlepagestructure);
components.set('contact-page-structure', contactpagestructure);
components.set('editorial-breadcrumb', editorialbreadcrumb);
components.set('home-page-structure', homepagestructure);
components.set('FlexibleHero', FlexibleHero);
components.set('card-list', cardlist);
components.set('card', card);
components.set('faqs', faqs);
components.set('hero-header', heroheader);
components.set('icon-text-card-block', icontextcardblock);
components.set('icon-text-card-item', icontextcarditem);
components.set('image-and-text-block', imageandtextblock);
components.set('image-with-content-blocks', imagewithcontentblocks);
components.set('introduction', introduction);
components.set('text-card-block', textcardblock);
components.set('text-card-item', textcarditem);
components.set('CommunityCardRow.props', CommunityCardRowprops);
components.set('CommunityCardRow', CommunityCardRow);
components.set('GuideOverview', GuideOverview);
components.set('child-guides', childguides);
components.set('guide-faqs', guidefaqs);
components.set('guide-header', guideheader);
components.set('guide-navigation-header', guidenavigationheader);
components.set('guide-navigation-structure', guidenavigationstructure);
components.set('guide-structure', guidestructure);

export const componentBuilder = new ComponentBuilder({ components });

export const moduleFactory = componentBuilder.getModuleFactory();
